import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
// import EventsContent from "./EventsContent";
// import EventsTable from "./EventsTable";
// import EventsData from "./EventsData";
// import Pagination from "./Pagination";
import "../../../css/admin.css";
import {
  AllEvents,
  FilteredEvents,
  EventsByuserId,
  EventCancel,
} from "../../../actions/auth";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import SmartDataTable from "react-smart-data-table";
import Loader from "../loader";
import Pagination from "react-js-pagination";
import Footer from "./Footer";

const generateData = (eventslist = 0, numTransactResults = 0, pageNo = 1) => {
  let total = numTransactResults || 0;
  if (typeof numTransactResults === "string") {
    total = parseInt(numTransactResults, 10);
  }
  const EventsTable = [];
  for (let i = 0; i < total; i += 1) {
    //   var a = i;
    var date = new Date(eventslist[i].event_date);
    var month = date.getMonth();
    var todayDate = date.getDate();
    var year = date.getFullYear();
    const offset = (pageNo - 1) * total;
    debugger;
    EventsTable.push({
      No: offset + (i + 1),
      EventName: eventslist[i].title,
      eventid: eventslist[i]._id,
      datetime:
        eventslist[i].event_date +
        // month +
        // "/" +
        // todayDate +
        // "/" +
        // year +
        " at " +
        eventslist[i].event_time,
      hostname: eventslist[i].hostname,
      status: eventslist[i].status,
    });
  }
  return EventsTable;
};

const Events = (props) => {
  const dispatch = useDispatch();
  // const evets = useSelector((state) => state.auth.events);
  const loading = useSelector((state) => state.auth.eventloading);
  const [numTransactResults, setNumTransactResults] = useState(0);
  const [EventsTable, setEventsTable] = useState(null);
  const [filteredTable, setFilteredTable] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [totalFilterCount, setTotalFilterCount] = useState(0);
  const [type, setType] = useState("");
  const [search, setSearch] = useState("");
  const [userId, setUserId] = useState(props.match.params.userid);
  const [eventList, setEventList] = useState();
  const [pageNo, setPageNo] = useState(1);
  const [filterList, setFilterList] = useState();

 
  const [pageRes, setPageRes] = useState("");

  useEffect(async () => {
    if (userId !== "" && userId !== undefined) {
      //console.log(userId);
      await dispatch(
        EventsByuserId(
          userId,
          pageNo,
          numTransactResults,
          type,
          search ? search : ""
        )
      )
        .then((res) => {
          res &&
            res.data &&
            setEventsTable(
              generateData(res.data.events, res.data.events.length)
            );
          res && res.data && setEventList(res.data.events);
          res && res.data && setNumTransactResults(res.data.events.length);
          res && res.data && setTotalCount(res.data.totalCount);
          res && res.data && setPageRes(res.data.events);
        })
        .catch((err) => {
          //console.log("haierr ", err);
        });
    } else if (userId == undefined) {
      (await loading) &&
        dispatch(AllEvents(pageNo)).then((res) => {
          //console.log("yes", res);

          res &&
            res.data &&
            setEventsTable(
              generateData(res.data.events, res.data.events.length)
            );
          res && res.data && setEventList(res.data.events);
          res && res.data && setNumTransactResults(res.data.events.length);
          res && res.data && setTotalCount(res.data.totalCount);
          res && res.data && setPageRes(res.data.events);
        });
    }
    //   evets &&   evets.data &&
    //       setEventsTable(generateData(evets.data.events, evets.data.events.length));
    //    evets &&  evets.data && setNumTransactResults(evets.data.events.length);
  }, []);
  // const EventsTable = []
  // const numTransactResults = 5

  const onSearch = async (s) => {
    if (userId && s.target.value) {
      const tosearch = s.target.value;
      setSearch(s.target.value);
      await dispatch(EventsByuserId(userId, 1, tosearch, s.target.value)).then(
        (res) => {
          setPageNo(1);
          res.data &&
            setEventsTable(
              generateData(res.data.events, res.data.events.length)
            );
          res.data && setNumTransactResults(res.data.events.length);
          res.data && setTotalCount(res.data.totalCount);
          res && res.data && setPageRes(res.data.events);
        }
      );
    } else if (s.target.value && !userId) {
      const tosearch = s.target.value;
      setSearch(s.target.value);
      await dispatch(FilteredEvents(1, tosearch, s.target.value)).then(
        (res) => {
          setPageNo(1);
          res.data &&
            setEventsTable(
              generateData(res.data.events, res.data.events.length)
            );
          res.data && setNumTransactResults(res.data.events.length);
          res.data && setTotalCount(res.data.totalCount);
          res && res.data && setPageRes(res.data.events);
        }
      );
    } else {
      setSearch("");
      dispatch(AllEvents(pageNo)).then((res) => {
        res &&
          res.data &&
          setEventsTable(generateData(res.data.events, res.data.events.length));
        res && res.data && setEventList(res.data.events);
        res && res.data && setNumTransactResults(res.data.events.length);
        res && res.data && setTotalCount(res.data.totalCount);
        res && res.data && setPageRes(res.data.events);
      });
    }
  };
  const onChangePage = (page) => {
    setPageNo(page);

    const action =
      userId == undefined && search === "" && type === 0
        ? AllEvents(page)
        : FilteredEvents(page, type, search);

    dispatch(action)
      .then((res) => {
        if (res && res.data) {
          const eventData = res.data.events || [];
          const totalCount = res.data.totalCount || 0;

          setEventsTable(generateData(eventData, numTransactResults, page));
          setEventList(eventData);
          setNumTransactResults(eventData.length);
          setTotalCount(totalCount);
          setPageRes(eventData);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // const onChangePage = (e) => {
  //   var page = e;
  //   //console.log("cc", userId, search, type);
  //   setPageNo(page);
  //   userId == undefined && search === "" && type === 0
  //     ? dispatch(AllEvents(page))
  //         .then((res) => {
  //           if (res) {
  //             res &&
  //               res.data &&
  //               setEventsTable(
  //                 generateData(res.data.events, res.data.events.length)
  //               );
  //             res && res.data && setEventList(res.data.events);
  //             res && res.data && setNumTransactResults(res.data.events.length);
  //             res && res.data && setTotalCount(res.data.totalCount);
  //             res && res.data && setPageRes(res.data.events);
  //           }
  //         })
  //         .catch((err) => {
  //           console.error(err);
  //         })
  //     : dispatch(FilteredEvents(page, search, type)).then((res) => {
  //         res.data &&
  //           setEventsTable(
  //             generateData(res.data.events, res.data.events.length)
  //           );
  //         res && res.data && setFilterList(res.data.events);
  //         res.data && setNumTransactResults(res.data.events.length);
  //         res.data && setTotalCount(res.data.totalCount);
  //         res && res.data && setPageRes(res.data.events);
  //       });
  // };
  const CancelEvent = async (eventId) => {
    await dispatch(EventCancel(eventId)).then((rr) => {
      if (rr.success == true) {
        //console.log("done");
      }
    });
  };
  const stautschange = async (s) => {
    debugger;
    setType(s.target.value);
    if (s.target.value && userId) {
      const tosearch = s.target.value;
      setType(s.target.value);
      await dispatch(
        EventsByuserId(userId, 1, s.target.value, search ? search : "")
      ).then((res) => {
        setPageNo(1);
        res.data &&
          setEventsTable(generateData(res.data.events, res.data.events.length));
        res.data && setNumTransactResults(res.data.events.length);
        res.data && setTotalCount(res.data.totalCount);
        res && res.data && setPageRes(res.data.events);
      });
    } else if (s.target.value && !userId) {
      debugger;
      setPageNo(1);
      const tosearch = search;
      await dispatch(
        FilteredEvents(1, s.target.value, search ? search : "")
      ).then((res) => {
        res.data &&
          setEventsTable(generateData(res.data.events, res.data.events.length));
        res.data && setNumTransactResults(res.data.events.length);
        res.data && setTotalCount(res.data.totalCount);
        res && res.data && setPageRes(res.data.events);
      });
    }
  };

  useEffect(() => {
    if (filterList != undefined) {
      setEventList(filterList);
    }
  }, []);
  // for (let i = 0; i < numTransactResults; i++) {
  //     EventsTable.push({
  //     EventName: faker.name.findName(),
  //     eventid: faker.datatype.number(),
  //     datetime: faker.datatype.number(),
  //     amount:  faker.datatype.number(),
  //     status:  faker.name.findName(),
  //   })
  // }
  const headers = {
    EventName: {
      text: "Event Name",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        //   //console.log(row.eventid)
        return (
          <>
            <p style={{ cursor: "pointer" }}>
              {/* <input type="checkbox" className="mr-2" /> */}
              <Link
                className="profileLinks"
                to={`/events-details/${row.eventid}`}
              >
                {value}
              </Link>
            </p>
          </>
        );
      },
    },
    eventid: {
      text: "Event ID",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>{value}</p>
          </>
        );
      },
    },
    datetime: {
      text: "Date and Time",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>{value}</p>
          </>
        );
      },
    },
    hostname: {
      text: "Host",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>{value}</p>
          </>
        );
      },
    },
    status: {
      text: "Status",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>{value}</p>
          </>
        );
      },
    },
    action: {
      text: "Action",
      invisible: false,
      sortable: false,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            {row.status == "Past" ? (
              "expired"
            ) : row.status == "Cancelled" ? (
              "Already Cancelled"
            ) : (
              <div className="dropdown">
                <button
                  className="btn btn-secondary dropdown-toggle statusBtn "
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Status
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <a
                    className="dropdown-item"
                    href="/events"
                    onClick={() => CancelEvent(row.eventid)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            )}
          </>
        );
      },
    },
  };

  var pageArray = [];
  if (filterList != undefined) {
    pageArray =
      eventList &&
      eventList.map((comment, index) => {
        return index == 0 ? comment.showPagination : [];
      });
  } else {
    pageArray =
      eventList &&
      eventList.map((comment, index) => {
        return index == 0 ? comment.showPagination : [];
      });
  }

  return (
    <div className="EventsWrap">
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content-wrap">
            <Header />
            <div className="EventsContentWrap">
              <div className="container-fluid">
                <div className="card user-card shadow mb-4">
                  <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">
                      Events
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="row pt-2">
                      <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                        <div className="Search-Field">
                          <label className="form-label fields-label">
                            Search
                          </label>
                          <input
                            type="search"
                            className="form-control input-fields"
                            id="searchbyevent"
                            placeholder="By Event Name"
                            onChange={(rr) => {
                              onSearch(rr);
                            }}
                          />
                          <i className="fas fa-search search-icon"></i>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-12 col-12">
                        <label className="form-label fields-label">
                          Filter by Event Status
                        </label>
                        <select
                          className="form-select form-control slect-field"
                          aria-label="filter"
                          placeholder="Filter by Event Status"
                          onChange={(rr) => {
                            stautschange(rr);
                          }}
                        >
                          <option value="0">All</option>
                          <option value="1">Published</option>
                          <option value="2">Past</option>
                          <option value="3">Cancelled</option>
                          <option value="4">In progress</option>
                        </select>
                      </div>
                    </div>

                    <div className="eventsDataWrap">
                      <div className="">
                        <div className=" EventsData ps-0">
                          {/* <div className="row pt-2 align-items-center">
                    <div className="col-lg-3 col-md-4 col-sm-12 col-12">
                      <select
                        className="form-select form-control slect-field"
                        aria-label="filter"
                        placeholder="Filter by Event Status"
                      >
                        <option selected>Bulk Action</option>
                        <option value="1">Cancel</option>
                        <option value="2">Draft</option>
                      </select>
                    </div>
                    <Link to="/" className="ApplyBtn">
                      Apply to selected
                    </Link>
                    <Link to="/" className="linkks">
                      {" "}
                      1 item selected{" "}
                    </Link>
                    <Link to="/" className="linkks">
                      {" "}
                      Deselect all
                    </Link>
                  </div> */}
                          <SmartDataTable
                            //data='/v2/questions'
                            data={EventsTable}
                            dataKey=""
                            headers={headers}
                            //   orderedHeaders={transactionsOrderedHeaders}
                            //   hideUnordered={hideUnordered}
                            name="test-table"
                            className="ui compact selectable table eventsDataTable myEventtabel"
                            //   filterValue={filterValue}
                            // perPage={3}
                            //sortable
                            // withToggles
                            withLinks
                            withHeader
                            loader={<Loader />}
                            // onRowClick={this.onRowClick}
                            parseImg={{
                              style: {
                                border: "1px solid #ddd",
                                borderRadius: "2px",
                                padding: "3px",
                                width: "60px",
                              },
                            }}
                            dynamic
                            emptyTable={
                              <div
                                style={{
                                  alignSelf: "center",
                                  color: "#000",
                                  textAlign: "center",
                                }}
                              >
                                No Records Found
                              </div>
                            }
                          />
                        </div>
                      </div>
                    </div>
                    {
                      pageRes?.length > 0 && (
                        <div className="d-flex justify-content-between ">
                          <div className="my-records-number ">
                            <p
                              style={{
                                color: "#000",
                              }}
                            >
                              Showing {(pageNo - 1) * numTransactResults + 1} to{" "}
                              {pageNo * numTransactResults} of {totalCount}{" "}
                              entries
                            </p>
                          </div>

                          <Pagination
                            activePage={pageNo}
                            // itemsCountPerPage={totalFilterCount}
                            totalItemsCount={
                              // totalFilterCount != 0
                              //   ? totalFilterCount
                              //   : totalCount
                              totalCount
                            }
                            pageRangeDisplayed={5}
                            onChange={
                              onChangePage
                              // totalCount > totalFilterCount
                              //   ? onChangePage
                              //   : null
                            }
                            itemClass="page-item"
                            linkClass={
                              totalCount && totalCount > 0
                                ? "page-link"
                                : "page-link disabled"
                            }
                          />
                        </div>
                      )
                      //   : (
                      //   ""
                      // )
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Events;
